import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-form-select',
  template: `
    <div class="dynamic-field form-group form-select" [formGroup]="group">
      <label>{{ config.label }}</label>
      <select class="form-control" [formControlName]="config.name">
        <option value="">{{ config.placeholder }}</option>
        <option *ngFor="let option of config.options" value="{{option.value}}">
          {{ option.name }}
        </option>
      </select>
    </div>
  `,
})
export class FormSelectComponent {
  config;
  group: FormGroup;
}
